import React, { useEffect } from 'react';
import InfiniteMarquee from 'vanilla-infinite-marquee';
import Img1 from '../Assets/MoUs/GTN.png'
import Img2 from '../Assets/MoUs/LDC.png'
import Img3 from '../Assets/MoUs/PRIST.jpg'
import Img4 from '../Assets/MoUs/SAVEETHA.png'
import Img5 from '../Assets/MoUs/VSB.jpg'
import Img6 from '../Assets/MoUs/ANJAC.png'
import Img7 from '../Assets/MoUs/MTNC.png'
import Img8 from '../Assets/MoUs/MTWU.png'
import Img9 from '../Assets/MoUs/PEC.png'
import Img10 from '../Assets/MoUs/PSG.png'
import Img11 from '../Assets/MoUs/SRIPS.png'
import Img12 from '../Assets/MoUs/TAC.png'
import Img13 from '../Assets/MoUs/TCM.png'
import Img14 from '../Assets/MoUs/TMC.png'
import Img15 from '../Assets/MoUs/VHNSNC.png'
import Img16 from '../Assets/MoUs/VMRF.png'
import Img17 from '../Assets/MoUs/BDSC.jpg'
import Img18 from '../Assets/MoUs/BMT.png'
import Img19 from '../Assets/MoUs/DSU.png'
import Img20 from '../Assets/MoUs/KAHE.png'
import Img21 from '../Assets/MoUs/MMC.png'
import Img22 from '../Assets/MoUs/PGTS.png'
import Img23 from '../Assets/MoUs/PKN.png'
import Img24 from '../Assets/MoUs/REC.png'
import Img25 from '../Assets/MoUs/RKSC.png'


const InfiniteMarqueeComp = () => {
  const images = [Img1, Img2, Img3, Img4, Img5, Img6, Img7, Img8, Img9, Img10, Img11, Img12, Img13, Img14, Img15, Img16, Img17, Img18, Img19, Img20, Img21, Img22, Img23, Img24, Img25];

  useEffect(() => {
    const marquee = new InfiniteMarquee({
      element: '.marquee-container',
      speed: 100000,
      smoothedges: true,
      direction: 'left',
      duplicateCount: 2,
      pauseOnHover: true,
      mobileSettings: {
        direction: 'left',
        speed: 20000,
      }
    });

    return () => {
      marquee.destroy();
    };
  }, []);

  return (
    <div className="marquee-container InfiniteMarqueeComp">
      {images.map((img, index) => (
        <img key={index} src={img} alt={`MoU ${index + 1}`} style={{margin: '0 2rem'}} className='MarqueeImg'/>
      ))}
    </div>
  )
}

export default InfiniteMarqueeComp